// src/features/plan/PlanExpandCaret.jsx
//
// Shared expand/collapse caret used by both PlanMatrixRow (market-row
// expanders) and StrategyBand (band toggle) so their visual treatment
// stays byte-for-byte identical.
//
// Props:
//   isExpanded  {boolean}  — when true the caret rotates 180° (pointing up)
//   testId      {string=}  — optional data-testid; callers supply their own

import React from "react";
import { T } from "../../app/tokens.js";

export function PlanExpandCaret({ isExpanded, testId, color }) {
  return (
    <span
      data-testid={testId}
      style={{
        width:          28,
        height:         28,
        display:        "inline-flex",
        alignItems:     "center",
        justifyContent: "center",
        fontSize:       "24px",
        color:          color ?? T.light,
        borderRadius:   6,
        transform:      isExpanded ? "rotate(180deg)" : "none",
        transition:     "transform 120ms ease",
        flexShrink:     0,
      }}
    >
      ▾
    </span>
  );
}
